module.exports = __webpack_public_path__ + "static/media/Go4_Logo_Login.5264b774.png";